import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const cached = localStorage.getItem("iat_user");
    const token = localStorage.getItem("iat_token");
    if (cached && token) {
      try { setUser(JSON.parse(cached)); } catch {}
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("iat_user", JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem("iat_token");
        localStorage.removeItem("iat_user");
        setUser(null);
      }).finally(() => setReady(true));
    } else {
      setReady(true);
    }
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("iat_token", r.data.token);
    localStorage.setItem("iat_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };
  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    // NEW: Skool gate returns { verification_required, email, message } instead of a token.
    // Caller inspects this to show the "check your email" screen.
    if (r.data && r.data.verification_required) return r.data;
    localStorage.setItem("iat_token", r.data.token);
    localStorage.setItem("iat_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("iat_token");
    localStorage.removeItem("iat_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, signup, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
